module.exports = {
  siteTitle: "Hi! I'm Rafael!",
  siteDescription: `This is my CV and Code Portfolio`,
  keyWords: ['gatsbyjs', 'react', 'curriculum', 'rafaelcmm', 'github', 'cv'],
  authorName: 'Rafael Carvalho Monteiro',
  githubUsername: 'rafaelcmm',
  authorAvatar: '/images/favicon.jpg',
  authorDescription: `I'm a full-stack software engineer currently focused in frontend development with React, React Native and Flutter.<br/><br/>
  I worked in multiple stacks (React, React Native, AngularJs, Angular, Java, Flutter...), environments and types of companies (Startup, medium size and big corporate).<br/><br/>
  I currently work remotely as a software engineer and mainly working with <strong>Javascript, React/ReactNative, NodeJS and Dart/Flutter.</strong>`,
  skills: [
    {
      name: 'HTML',
      level: 100,
    },
    {
      name: 'CSS',
      level: 85,
    },
    {
      name: 'Javascript',
      level: 100,
    },
    {
      name: 'Dart/Flutter',
      level: 85,
    },
    {
      name: 'React',
      level: 95,
    },
    {
      name: 'React Native',
      level: 80,
    },
    {
      name: 'NodeJs',
      level: 70,
    },
    {
      name: 'Git',
      level: 75,
    },
    {
      name: 'Angular/AngularJS',
      level: 90,
    },
  ],
  jobs: [
    {
      company: 'ITWorks Network Group',
      begin: {
        month: 'JUN',
        year: '2019',
      },
      duration: null,
      location: 'Remote',
      occupation: 'Software Engineer',
      description:
        'Working mainly to architect and maintain frontend projects using various technologies like React, React Native and Flutter. As a lead software engineer, I am responsible for manage teams of developers and deliver the best solution in terms of performance.',
    },
    {
      company: 'Agenda Edu',
      begin: {
        month: 'AUG',
        year: '2018',
      },
      duration: '1 years and 2 months',
      location: 'Fortaleza/CE - Brazil',
      occupation: 'Frontend Developer',
      description:
        'Part of a front-end developing team, focused on mobile development, i’m responsible for developing solutions to company’s app, an electronic school agenda, with best front-end rendering performance, to ensure that most of parents use with better experience in many kinds of devices. I’m always helping back-end team with data model as well',
    },
    {
      company: 'Casa Magalhães',
      begin: {
        month: 'AUG',
        year: '2017',
      },
      duration: '1 year',
      location: 'Fortaleza/CE - Brazil',
      occupation: 'FULLSTACK DEVELOPER',
      description:
        'As an tecnology developer, I was part of a team responsible of architect and program the new projects of the company. Always studying new architectures of software, to supply company\'s demands, creating solutions in many languages and platforms.',
    },
    {
      company: 'LabelNET',
      begin: {
        month: 'SEP',
        year: '2015',
      },
      duration: '3 years',
      location: 'Fortaleza/CE - Brazil',
      occupation: 'Software developer',
      description:
        'Here, I use my skills in web development, to create from zero-to-app the online courses platform of the company. My accomplishments in this company reduced a lot the piracy problems, increasing the profits. I also take care of marketing stuff in social medias and email marketing',
    },
  ],
  // publications: [
  //   {
  //     title: 'React Native intermediate level',
  //     company_medium: 'OpenWebinars',
  //     date: {
  //       month: 'jun',
  //       year: '2019',
  //     },
  //     link: 'https://openwebinars.net/cursos/react-native-intermedio/',
  //     description:
  //       'Online training recorded for spanish e-learning platform. The training is for developers who know a little bit of ReactNative and wants to learn more about the platform',
  //   },
  //   {
  //     title: 'React Native for beginners',
  //     company_medium: 'OpenWebinars',
  //     date: {
  //       month: 'jun',
  //       year: '2019',
  //     },
  //     link: 'https://openwebinars.net/cursos/react-native-principiantes/',
  //     description:
  //       'Online training recorded for spanish e-learning platform. The training is for JS developers willing to learn the basics of ReactNative',
  //   },
  // ],
  education: [
    {
      school: 'University Estácio',
      degree: 'Bachelor degree',
      field: 'Information Systems',
      startYear: 2018,
      endYear: 2021,
    },
  ],
  languages: [
    {
      language: 'Portuguese',
      level: 'Native tongue',
      code: 'BR',
    },
    {
      language: 'English',
      level: 'Fluid Written & Spoken',
      code: 'US',
    },
  ],
  social: {
    linkedin: 'https://www.linkedin.com/in/rafaelcmm/',
    github: 'https://github.com/rafaelcmm/',
    email: 'rafael@qwkin.io',
  },
  // hobbies: [
  //   {
  //     name: 'Football',
  //     icon: 'FaFutbol',
  //   },
  //   {
  //     name: 'Photography',
  //     icon: 'FaCamera',
  //   },
  //   {
  //     name: 'Hiking',
  //     icon: 'FaHiking',
  //   },
  //   {
  //     name: 'Traveling',
  //     icon: 'FaPlane',
  //   },
  //   {
  //     name: 'Movies & Series',
  //     icon: 'FaTv',
  //   },
  // ],
  siteUrl: 'https://rafaelcmm.github.io',
  siteCover: '/images/cover.jpeg',
  background_color: '#25303B',
  theme_color: '#25303B',
  display: 'minimal-ui',
  icon: 'src/favicon.jpg',
  headerLinks: [
    // {
    //   label: 'Alvaro Jimenez Martin',
    //   url: '/',
    // },
    {
      label: 'About',
      url: 'about',
    },
    {
      label: 'Skills',
      url: 'skills',
    },
    {
      label: 'Experience',
      url: 'experience',
    },
    // {
    //   label: 'Publications',
    //   url: 'publications',
    // },
    {
      label: 'Education',
      url: 'education',
    },
    // {
    //   label: 'Hobbies',
    //   url: 'hobbies',
    // },
    // {
    //   label: 'Contact',
    //   url: 'contact',
    // },
  ],
};
